"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "next-intl";
import { usePortfolios } from "@/components/modules/portfolio/api/queries/usePortfolios";
import { useAdminUserPortfolios } from "@/components/modules/admin/api/queries/useAdminUserPortfolios";
import { getPortfolioRoomBusinesses } from "@/components/modules/portfolio/hooks/usePortfolioUtils";
import type { BusinessUnitsSchemaType, GetRealEstateManagementSchemaType } from "@/components/modules/portfolio/api/schemas/schemas";
import { useNewRoomListingContext } from "../../../NewRoomListingContext";
import { applyUnitAssociation } from "./applyUnitAssociation";
export function usePropertyAssociationSelect() {
  const $ = _c(22);
  const t = useTranslations("modules.listings.addRoomListing.houseDetails");
  const {
    setValue,
    control
  } = useFormContext();
  const {
    adminTargetUserId
  } = useNewRoomListingContext();
  const isAdminFlow = Boolean(adminTargetUserId);
  const ownPortfolios = usePortfolios();
  const adminUserPortfolios = useAdminUserPortfolios(adminTargetUserId);
  const portfolios = isAdminFlow ? adminUserPortfolios.data?.data : ownPortfolios.data?.data;
  const resource = getPortfolioRoomBusinesses(portfolios);
  const eligible = resource.portfolios.length > 0;
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "associatedUnitId"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const associatedUnitId = useWatch(t0);
  let t1;
  if ($[2] !== control) {
    t1 = {
      control,
      name: "associatedUnitTitle"
    };
    $[2] = control;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const associatedUnitTitle = useWatch(t1);
  let t2;
  if ($[4] !== control) {
    t2 = {
      control,
      name: "associatedPortfolioTitle"
    };
    $[4] = control;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const associatedPortfolioTitle = useWatch(t2);
  let t3;
  bb0: {
    if (!associatedUnitId) {
      t3 = undefined;
      break bb0;
    }
    for (const portfolio of resource.portfolios) {
      for (const business of portfolio.businesses ?? []) {
        const unit = business.units?.find(u => u.id === associatedUnitId);
        if (unit) {
          t3 = unit.realEstateAssociated?.title;
          break bb0;
        }
      }
    }
    t3 = undefined;
  }
  const occupiedBy = t3;
  let t4;
  if ($[6] !== setValue) {
    t4 = t5 => {
      const {
        unit: unit_0,
        portfolio: portfolio_0
      } = t5;
      return applyUnitAssociation(setValue, {
        unit: unit_0,
        portfolio: portfolio_0
      });
    };
    $[6] = setValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleChange = t4;
  let t5;
  if ($[8] !== setValue) {
    t5 = () => {
      setValue("associatedUnitId", undefined, {
        shouldDirty: true
      });
      setValue("associatedUnitTitle", undefined, {
        shouldDirty: true
      });
      setValue("associatedPortfolioTitle", undefined, {
        shouldDirty: true
      });
      setValue("associatedPropertyImages", undefined, {
        shouldDirty: true
      });
      setValue("latitude", undefined, {
        shouldDirty: true
      });
      setValue("longitude", undefined, {
        shouldDirty: true
      });
      setValue("bedrooms", undefined, {
        shouldDirty: true
      });
      setValue("bathrooms", undefined, {
        shouldDirty: true
      });
      setValue("petFriendly", undefined, {
        shouldDirty: true
      });
      setValue("contract", undefined, {
        shouldDirty: true
      });
      setValue("smokingAllowed", undefined, {
        shouldDirty: true
      });
      setValue("locationNormalizedName", undefined, {
        shouldDirty: true
      });
      setValue("parishName", undefined, {
        shouldDirty: true
      });
      setValue("municipalityName", undefined, {
        shouldDirty: true
      });
      setValue("districtName", undefined, {
        shouldDirty: true
      });
    };
    $[8] = setValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleRemove = t5;
  let t6;
  if ($[10] !== associatedPortfolioTitle || $[11] !== associatedUnitId || $[12] !== associatedUnitTitle) {
    t6 = {
      unitId: associatedUnitId,
      unitTitle: associatedUnitTitle,
      portfolioTitle: associatedPortfolioTitle
    };
    $[10] = associatedPortfolioTitle;
    $[11] = associatedUnitId;
    $[12] = associatedUnitTitle;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== eligible || $[15] !== handleChange || $[16] !== handleRemove || $[17] !== occupiedBy || $[18] !== resource || $[19] !== t || $[20] !== t6) {
    t7 = {
      t,
      resource,
      eligible,
      value: t6,
      occupiedBy,
      handleChange,
      handleRemove
    };
    $[14] = eligible;
    $[15] = handleChange;
    $[16] = handleRemove;
    $[17] = occupiedBy;
    $[18] = resource;
    $[19] = t;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}